// extracted by mini-css-extract-plugin
export default {"dg":"OAMdASnahxYcQbYnKmD_","ac":"LJxXhJa8DFUTxD4OD3MD"};